var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var version = "1.7.0";
var _default = version;
exports["default"] = _default;
export default exports;